import PropTypes from 'prop-types';
import { m } from 'framer-motion';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
//
import Logo from './Logo';

// ----------------------------------------------------------------------

LogoLoader.propTypes = {
    size: PropTypes.number,
    sx: PropTypes.object,
};

export default function LogoLoader({ size = 100, sx, ...other }) {
    const theme = useTheme();

    // Circle properties
    const strokeWidth = 5;
    const radius = 50 - strokeWidth / 2;
    const circumference = 2 * Math.PI * radius;

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                width: size,
                height: size,
                ...sx,
            }}
            {...other}
        >
            {/* Centered Logo - Increased to 85% size for "fit" */}
            <Logo
                disabledLink
                sx={{
                    width: size * 0.85,
                    height: size * 0.85,
                    zIndex: 9,
                    padding: 0,
                    backgroundColor: 'transparent',
                    boxShadow: 'none'
                }}
            />

            {/* SVG Spinner Ring */}
            <Box
                component={m.svg}
                viewBox="0 0 100 100"
                animate={{ rotate: 360 }}
                transition={{
                    duration: 1.5,
                    ease: "linear",
                    repeat: Infinity
                }}
                sx={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                }}
            >
                {/* Background Track (faint) */}
                <circle
                    cx="50"
                    cy="50"
                    r={radius}
                    fill="none"
                    stroke={theme.palette.primary.main}
                    strokeOpacity={0.15}
                    strokeWidth={strokeWidth}
                />

                {/* Animated Tail */}
                <m.circle
                    cx="50"
                    cy="50"
                    r={radius}
                    fill="none"
                    stroke={theme.palette.primary.main}
                    strokeWidth={strokeWidth}
                    strokeLinecap="round"
                    strokeDasharray={circumference}
                    initial={{ strokeDashoffset: circumference }}
                    animate={{ strokeDashoffset: [circumference * 0.8, circumference * 0.2, circumference * 0.8] }} // "Breathing" tail effect
                    transition={{
                        duration: 2,
                        ease: "easeInOut",
                        repeat: Infinity
                    }}
                />
            </Box>
        </Box>
    );
}
